import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoadingState {
  count: number;
  translationKey?: string;
  translationParams?: Record<string, string | number>;
}
const initialState: LoadingState = {
  count: 0,
  translationKey: undefined,
  translationParams: undefined,
};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    startLoading: (state, action: PayloadAction<string | undefined>) => {
      state.count += 1;
      if (action.payload) {
        state.translationKey = action.payload;
      }
    },
    updateLoadingMessage: (
      state,
      action: PayloadAction<{
        translationKey?: string;
        translationParams?: Record<string, string | number>;
      }>,
    ) => {
      if (action.payload.translationKey !== undefined) {
        state.translationKey = action.payload.translationKey;
      }
      state.translationParams = action.payload.translationParams;
    },
    stopLoading: (state) => {
      state.count = Math.max(0, state.count - 1);
      if (state.count === 0) {
        state.translationKey = undefined;
        state.translationParams = undefined;
      }
    },
  },
});

export const { startLoading, updateLoadingMessage, stopLoading } =
  loadingSlice.actions;
export default loadingSlice.reducer;
